import { render } from "./DeleteInfo.vue?vue&type=template&id=03951953&scoped=true&ts=true"
import script from "./DeleteInfo.vue?vue&type=script&lang=ts"
export * from "./DeleteInfo.vue?vue&type=script&lang=ts"

import "./DeleteInfo.vue?vue&type=style&index=0&id=03951953&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03951953"]])

export default __exports__